// extracted by mini-css-extract-plugin
export default {"product_img":"Category_product_img__N9+FP"};